'use client';

import Loading from '@/components/loading';
import { useApp } from '@/contexts/app-context';
import { ReactNode } from 'react';

export default function Loader({ children }: { children: ReactNode }) {
  const { loading } = useApp();

  if (loading)
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loading className="h-8 w-8" />
      </div>
    );

  return children;
}
